<template>
    <div>
        <PesquisaPacienteModal
            v-if="modalSelecionarPaciente"
            v-model="modalSelecionarPaciente"
            @fecharModalPesquisaPaciente="fecharModalSelecionarPaciente"
            @confirmarPacienteSelecionado="selecionarPaciente"
        />
        <PesquisaDentistaModal
            v-if="modalSelecionarDentista"
            v-model="modalSelecionarDentista"
            @fecharModalPesquisaDentista="fecharModalSelecionarDentista"
            @confirmarDentistaSelecionado="selecionarDentista"
        />
        <confirm-modal
            v-model="modalExcluir"
            @modalAcaoCancelar="fecharModalExcluirEvento"
            @modalAcaoConfirmar="excluirEvento"
            :persistencia="false"
            mensagemInicial="Deseja realmente excluir o evento?"/>
        <v-dialog
            v-model="model"
            @click:outside="fecharModalOutsideClick"
            :persistent="modoEdicao"
            :max-width="maxWidth"
            style="padding: 0">
            <v-card class="rounded-lg overflow-hidden">
                <v-toolbar dark color="primary" elevation="2">
                    <v-icon left>mdi-calendar-clock</v-icon>
                    <v-toolbar-title class="d-inline-block text-truncate max-30 font-weight-bold">{{
                            dadosGerais.titulo
                        }}
                    </v-toolbar-title>
                    <v-spacer/>
                    <v-btn class="close__button" text @click="fecharModal" icon>
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-container fluid class="pa-6">
                    <v-card-text class="pa-0">
                        <v-row>
                            <v-col cols="12" md="6" class="pb-2">
                                <div class="d-flex align-center mb-1">
                                    <v-icon small color="primary" class="mr-2">mdi-account</v-icon>
                                    <span class="primary--text font-weight-medium"
                                          style="font-size: 14px">Paciente</span>
                                </div>
                                <p class="text-body-1 black--text mb-0">{{
                                        dadosGerais.pacienteNome | textoSemValor
                                    }}</p>
                            </v-col>
                            <v-col cols="12" md="6" class="pb-2">
                                <div class="d-flex align-center mb-1">
                                    <v-icon small color="primary" class="mr-2">mdi-tooth</v-icon>
                                    <span class="primary--text font-weight-medium"
                                          style="font-size: 14px">Dentista</span>
                                </div>
                                <p class="text-body-1 black--text mb-0">{{
                                        dadosGerais.dentistaNome | textoSemValor
                                    }}</p>
                            </v-col>
                        </v-row>

                        <v-divider class="my-4"></v-divider>

                        <v-row>
                            <v-col cols="12" v-if="!modoEdicao">
                                <div class="d-flex align-center mb-1">
                                    <v-icon small color="primary" class="mr-2">mdi-text-subject</v-icon>
                                    <span class="primary--text font-weight-medium"
                                          style="font-size: 14px">Descrição</span>
                                </div>
                                <p class="text-body-1 black--text text-justify">{{ dadosGerais.descricao }}</p>
                            </v-col>
                            <v-col cols="12" class="pt-0 pb-0" v-if="modoEdicao">
                                <v-textarea
                                    v-model="dadosGerais.descricao"
                                    name="descricao"
                                    label="Descrição"
                                    placeholder="Informe a descrição do evento"
                                    outlined
                                    auto-grow
                                    counter="250"
                                    maxlength="250"
                                    prepend-inner-icon="mdi-text-subject">
                                    <template v-slot:label>
                                        Descrição
                                        <span class="ml-1 red--text">*</span>
                                    </template>
                                </v-textarea>
                            </v-col>
                        </v-row>

                        <v-row class="mt-2">
                            <v-col cols="12" md="7" v-if="!modoEdicao">
                                <div class="d-flex align-center mb-1">
                                    <v-icon small color="primary" class="mr-2">mdi-clock-outline</v-icon>
                                    <span class="primary--text font-weight-medium" style="font-size: 14px">Data e Horário</span>
                                </div>
                                <p class="text-body-1 black--text mb-0">
                                    <span class="text-capitalize">{{
                                            moment(dadosGerais.dataInicio).locale('pt-br').format('dddd, DD [de] MMMM')
                                        }}</span>
                                    <br>
                                    <span class="grey--text text--darken-2">{{
                                            moment(dadosGerais.dataInicio).format('HH:mm')
                                        }} - {{ moment(dadosGerais.dataFim).format('HH:mm') }}</span>
                                </p>
                            </v-col>
                            <v-col cols="12" md="5" v-if="!modoEdicao">
                                <div class="d-flex align-center mb-1">
                                    <v-icon small color="primary" class="mr-2">mdi-tag-outline</v-icon>
                                    <span class="primary--text font-weight-medium" style="font-size: 14px">Status</span>
                                </div>
                                <v-chip small :color="getStatusColor(dadosGerais.status)" dark font-weight-bold>
                                    {{ dadosGerais.statusNome }}
                                </v-chip>
                            </v-col>
                            <v-col cols="12" md="12" sm="12" xs="12" class="pt-0" v-if="modoEdicao">
                                <date-input-evento
                                    v-model="dadosGerais.dataInicio"
                                    :data-fim="dadosGerais.dataFim"
                                    @selecionarDuracao="atualizarDuracaoEvento"
                                    @atualizarData="atualizarData"
                                />
                            </v-col>
                            <v-col cols="12" md="12" sm="12" xs="12" class="pt-0" v-if="modoEdicao">
                                <span class="primary--text" style="font-size: 14px">Status</span>
                                <v-select
                                    v-model="dadosGerais.status"
                                    :items="statusEventoList"
                                    item-text="nome"
                                    item-value="valor"
                                    class="select-container"
                                    dense
                                    outlined
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                        <v-row wrap align-center white v-if="modoEdicao">
                            <v-col cols="12" md="12" sm="12" xs="12" class="pt-0">
                                <v-btn v-if="!pacienteSelecionado" depressed block color="primary"
                                       @click="abrirModalSelecionarPaciente">
                                    Selecionar Paciente
                                    <v-icon class="ml-2">people</v-icon>
                                </v-btn>
                                <div v-else class="container-paciente-evento">
                                    <div class="container-nome-paciente">
                                        <div class="selecionado-label">
                                            <span class="primary--text" style="font-size: 14px">Nome</span>
                                            <p>{{ pacienteSelecionado.nome }}</p>
                                        </div>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-btn v-on="on" icon color="primary"
                                                       @click="abrirModalSelecionarPaciente">
                                                    <v-icon>mdi-magnify</v-icon>
                                                </v-btn>
                                            </template>
                                            Alterar paciente
                                        </v-tooltip>
                                    </div>
                                    <div class="container-info-paciente">
                                        <div class="selecionado-label">
                                            <span class="primary--text" style="font-size: 14px">CPF/CNPJ</span>
                                            <p>{{ pacienteSelecionado.cnpjCpf | formatarCpfCnpj }}</p>
                                        </div>
                                        <div class="selecionado-label ml-5">
                                            <span class="primary--text" style="font-size: 14px">Sexo</span>
                                            <p>{{ pacienteSelecionado.sexo }}</p>
                                        </div>
                                        <div class="selecionado-label ml-5">
                                            <span class="primary--text" style="font-size: 14px">Telefone</span>
                                            <p>{{ pacienteSelecionado.telefone | formatarTelefone }}</p>
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row wrap align-center white v-if="modoEdicao">
                            <v-col cols="12" md="12" sm="12" xs="12" class="pt-0">
                                <v-btn v-if="!dentistaSelecionado" depressed block color="primary"
                                       @click="abrirModalSelecionarDentista">
                                    Selecionar Dentista
                                    <v-icon class="ml-2">mdi-tooth</v-icon>
                                </v-btn>
                                <div v-else class="container-dentista-evento">
                                    <div class="container-foto-dentista">
                                        <foto-avatar :foto-url="dentistaSelecionado.foto"
                                                     class-avatar="imagem-dentista"/>
                                    </div>
                                    <div class="container-info-dentista">
                                        <div class="container-nome-dentista">
                                            <div class="selecionado-label">
                                                <span class="primary--text" style="font-size: 14px">Nome</span>
                                                <p>{{ dentistaSelecionado.nome }}</p>
                                            </div>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn v-on="on" icon color="primary"
                                                           @click="abrirModalSelecionarDentista">
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                </template>
                                                Alterar dentista
                                            </v-tooltip>
                                        </div>
                                        <div class="container-sub-info-dentista">
                                            <div class="selecionado-label">
                                                <span class="primary--text" style="font-size: 14px">Cargo</span>
                                                <p>{{ dentistaSelecionado.cargo }}</p>
                                            </div>
                                            <div class="selecionado-label ml-5">
                                                <span class="primary--text" style="font-size: 14px">Sexo</span>
                                                <p>{{ dentistaSelecionado.sexo }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn @click="abrirModalExcluirEvento" color="grey" class="botao-excluir-evento mr-4" icon
                               outlined>
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                        <v-spacer/>
                        <div v-if="!modoEdicao">
                            <v-tooltip top v-if="dadosGerais.telefone">
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" icon class="mr-2" @click="enviarMensagemViaWhatsapp">
                                        <v-icon large color="green">mdi-whatsapp</v-icon>
                                    </v-btn>
                                </template>
                                Enviar mensagem por WhatsApp
                            </v-tooltip>
                            <v-tooltip top v-if="dadosGerais.pacienteId">
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" @click="acessarFicha" icon outlined class="mr-2">
                                        <v-icon>mdi-account-box</v-icon>
                                    </v-btn>
                                </template>
                                Acessar ficha do paciente
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" @click="ativarModoEdicao" icon outlined
                                           class="botao-cancelar-edicao">
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                </template>
                                Editar
                            </v-tooltip>
                        </div>
                        <div v-if="modoEdicao">
                            <v-btn class="botao-cancelar-edicao" @click="cancelarModoEdicao" outlined>Cancelar</v-btn>
                            <v-btn class="ml-5" @click="salvarEdicao" outlined>Salvar</v-btn>
                        </div>
                    </v-card-actions>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import {actionTypes} from '@/core/constants'
import ConfirmModal from '@/views/components/ConfirmModal.vue'
import DateInputEvento from '@/views/components/DateInputEvento.vue'
import PesquisaPacienteModal from '@/views/modais/PesquisaPacienteModal.vue'
import PesquisaDentistaModal from '@/views/modais/PesquisaDentistaModal.vue'
import FotoAvatar from '@/views/components/FotoAvatar.vue'

export default {
    name: 'ModalEventoAgenda',
    components: {FotoAvatar, PesquisaDentistaModal, PesquisaPacienteModal, DateInputEvento, ConfirmModal},
    props: {
        value: {
            type: Boolean,
            required: true
        },
        evento: {
            type: Object,
            required: true
        },
        maxWidth: {
            type: Number,
            default: 650
        }
    },
    data() {
        return {
            moment,
            modalExcluir: false,
            modoEdicao: false,
            dadosGeraisAnterior: this.evento,
            dadosGerais: {
                descricao: null,
                dataInicio: null,
                dataFim: null,
                status: null,
                statusNome: null,
            },
            duracaoEvento: 30,
            houveEdicao: false,
            pacienteSelecionado: null,
            dentistaSelecionado: null,
            modalSelecionarPaciente: false,
            modalSelecionarDentista: false,
            statusEventoList: [
                {nome: 'Agendado', valor: 'AGENDADO'},
                {nome: 'Em atendimento', valor: 'EM_ATENDIMENTO'},
                {nome: 'Confirmado', valor: 'CONFIRMADO'},
                {nome: 'Finalizado', valor: 'FINALIZADO'},
                {nome: 'Cancelado', valor: 'CANCELADO'},
                {nome: 'Desmarcou', valor: 'DESMARCOU'},
                {nome: 'Faltou', valor: 'FALTOU'},
            ],
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    mounted() {
        this.setarDados()
    },
    methods: {
        setarDados() {
            this.dadosGerais = _.cloneDeep(this.dadosGeraisAnterior)
            this.dadosGerais.dataInicio = this.dadosGeraisAnterior.start
            this.dadosGerais.dataFim = this.dadosGeraisAnterior.end

            if (this.dadosGerais.pacienteId) {
                this.pacienteSelecionado = {
                    id: this.dadosGerais.pacienteId,
                    nome: this.dadosGerais.pacienteNome,
                    sexo: null,
                    cnpjCpf: null,
                    telefone: null
                }
            }

            if (this.dadosGerais.dentistaId) {
                this.dentistaSelecionado = {
                    id: this.dadosGerais.dentistaId,
                    nome: this.dadosGerais.dentistaNome,
                    sexo: null,
                    cargo: null
                }
            }
        },
        fecharModal() {
            if (this.houveEdicao) {
                this.fecharModalAposAtualizacao()
            } else {
                this.model = false
                this.$emit('modalEventoAcaoFechar')
            }
        },
        fecharModalOutsideClick() {
            if (!this.modoEdicao) {
                this.fecharModal()
            }
        },
        fecharModalAposAtualizacao() {
            this.model = false
            this.$emit('modalEventoAcaoFecharAposAtualizar')
        },
        abrirModalExcluirEvento() {
            this.modalExcluir = true
        },
        fecharModalExcluirEvento() {
            this.modalExcluir = false
        },
        async excluirEvento() {
            await this.$store.dispatch(actionTypes.AGENDA.REMOVER_EVENTO, this.evento.id)
            this.fecharModalAposAtualizacao()
        },
        acessarFicha() {
            this.$router.push({name: 'PacienteFicha', params: {id: this.evento.pacienteId}})
        },
        ativarModoEdicao() {
            this.modoEdicao = true
        },
        cancelarModoEdicao() {
            this.modoEdicao = false
            this.setarDados()
        },
        atualizarDuracaoEvento(duracao) {
            this.duracaoEvento = duracao
        },
        atualizarData(data) {
            this.dadosGerais.dataInicio = moment(data).format('YYYY-MM-DDTHH:mm:ss')
        },
        async salvarEdicao() {
            if (this.isEventoValido()) {
                this.setMensagemLoading('Salvando edição do evento na agenda...')
                const inputEvento = this.montarDadosGerais()
                const resposta = await this.$store.dispatch(actionTypes.AGENDA.EDITAR_EVENTO, inputEvento)
                if (resposta) {
                    this.dadosGerais = resposta
                    this.salvarDadosParaEdicao()
                }
                this.mostrarNotificacaoSucessoDefault()
                this.modoEdicao = false
                this.houveEdicao = true
            }
        },
        salvarDadosParaEdicao() {
            this.dadosGeraisAnterior = this.dadosGerais
            this.dadosGeraisAnterior.start = this.dadosGerais.dataInicio
            this.dadosGeraisAnterior.end = this.dadosGerais.dataFim
        },
        isEventoValido() {
            if (!this.dadosGerais.descricao || this.dadosGerais.descricao.length < 5) {
                this.mostrarNotificacaoErro('A descrição deve possuir no mínimo 5 caracteres!')
                return false
            }
            return true
        },
        montarDadosGerais() {
            return {
                idEvento: this.dadosGerais.id,
                descricao: this.dadosGerais.descricao,
                dataInicio: moment(this.dadosGerais.dataInicio).format('YYYY-MM-DD HH:mm'),
                dataFim: moment(this.dadosGerais.dataInicio).add(this.duracaoEvento, 'm').format('YYYY-MM-DD HH:mm'),
                idDentista: this.dentistaSelecionado ? this.dentistaSelecionado.id : null,
                idPaciente: this.pacienteSelecionado ? this.pacienteSelecionado.id : null,
                status: this.dadosGerais.status
            }
        },
        abrirModalSelecionarPaciente() {
            this.modalSelecionarPaciente = true
        },
        fecharModalSelecionarPaciente() {
            this.modalSelecionarPaciente = false
        },
        selecionarPaciente(paciente) {
            this.pacienteSelecionado = paciente
            this.fecharModalSelecionarPaciente()
        },
        abrirModalSelecionarDentista() {
            this.modalSelecionarDentista = true
        },
        fecharModalSelecionarDentista() {
            this.modalSelecionarDentista = false
        },
        selecionarDentista(dentista) {
            this.dentistaSelecionado = dentista
            this.fecharModalSelecionarDentista()
        },
        enviarMensagemViaWhatsapp() {
            const url = `https://api.whatsapp.com/send?phone=55${this.dadosGerais.telefone}`
            window.open(url, '_blank')
        },
        getStatusColor(status) {
            const colors = {
                'AGENDADO': 'blue',
                'CONFIRMADO': 'green',
                'CANCELADO': 'red',
                'FINALIZADO': 'grey darken-1',
                'FALTOU': 'orange'
            }
            return colors[status] || 'primary'
        }
    }
}

</script>

<style scoped lang="stylus">

.max-30
    max-width 30vw

.botao-excluir-evento:hover
    color red !important

.botao-cancelar-edicao:hover
    color orange !important

.container-evento-selecionado
    padding-top 10px

.container-paciente-evento
    background-color #f8f9fa
    display flex
    flex-direction column
    justify-content center
    align-items flex-start
    padding 16px
    font-size 16px
    border-radius 12px
    border 1px solid #eee

.container-dentista-evento
    background-color #f8f9fa
    padding 16px
    font-size 16px
    border-radius 12px
    border 1px solid #eee
    display flex

.container-foto-dentista
    margin-right 10px

.container-info-dentista
    width 100%
    display flex
    flex-direction column

.container-nome-dentista
    width 100%
    display flex
    flex-direction row
    justify-content space-between

.container-sub-info-dentista
    display flex

.imagem-dentista
    height 90px
    width 90px
    border-radius 50%
    border 2px solid #eee

.container-nome-paciente
    width 100%
    display flex
    flex-direction row
    justify-content space-between

.container-info-paciente
    display flex
    margin-top 10px

.selecionado-label
    font-weight bold

    p
        color #5a5a5a


</style>